import { PencilSquareIcon } from "@heroicons/react/24/outline";
import PropTypes from "prop-types";

/** Opens the handwriting / e-pen pad. Matches SpeechMicButton styling. */
const HandwritingPenButton = ({
  onClick,
  disabled = false,
  className = "",
  size = "md",
}) => {
  const sizeClass =
    size === "sm" ? "h-7 w-7" : size === "lg" ? "h-10 w-10" : "h-9 w-9";
  const iconClass = size === "sm" ? "h-4 w-4" : "h-5 w-5";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title="Write with e-pen / finger"
      aria-label="Open handwriting pad"
      className={`inline-flex ${sizeClass} shrink-0 items-center justify-center rounded-full border-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 border-gray-400 bg-white text-gray-600 hover:border-[#217E90] hover:bg-[#E9F5FE] hover:text-[#217E90] focus:ring-[#217E90] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-gray-400 disabled:hover:bg-white disabled:hover:text-gray-600 ${className}`}
    >
      <PencilSquareIcon className={iconClass} aria-hidden />
    </button>
  );
};

HandwritingPenButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default HandwritingPenButton;
